export default __webpack_public_path__ + "static/media/logo.ce420d18.svg";